import { Box } from "@mui/material";
import { useContext, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import authorityUserType from "../../assets/data/TkAuthorityProperty";
import { labelids } from "../../assets/data/TkExplanationProperty";
import TkButton from "../../components/atoms/TkButton";
import TkInfoManual from "../../components/atoms/TkInfoManual";
import TkSearchForm from "../../components/molecules/TkSearchForm";
import TkAmountInput from "../../components/molecules/TkAmountInput";
import TkBackButton from "../../components/molecules/TkBackButton";
import TkContractorAndNumberLine from "../../components/molecules/TkContractorAndNumberLine";
import TkCsvUpload from "../../components/molecules/TkCsvUpload";
import TkDataTable from "../../components/molecules/TkDataTable";
import TkFakeTableLine from "../../components/atoms/TkFakeTableLine";
import { BusinessContext } from "../../context/businessContext";
import { GlobalContext } from "../../context/globalContext";
import { IAPI_STA020_Response } from "../../type/apiType";
import { StaffList } from "../../type/apiType/IAPI_STA020";
import { StaffList as StaffListUpdate } from "../../type/apiType/IAPI_STA005";
import TkPropertyMessageGet from "../../utils/TkPropertyMessageGet";
import { changeAmountFormat } from "../../utils/useTools";
import { SexFlug } from "../../assets/data/Constants";
import { TkGetCode } from "../../utils/TkGetCode";
import "./_style.scss";
import { httpAPI_FAC019, httpAPI_STA005, httpAPI_STA020 } from "./api/request";
import {
  facilitySelectList,
  fakeHeadTitleList,
  searchFormList,
  searchFormSchema,
} from "./parts";
import { IJob_32Props } from "../../type/contextType/businessContext/IJob_32";
import { IJob_11Props } from "../../type/contextType/businessContext/IJob_11";
import _ from "lodash";
import TkMessageDialog from "../../components/molecules/TkMessageDialog";

interface CustomType {
  salaryTableAmtDefault?: number;
  salaryTableAmtError?: string;
  salaryAdjustmentAmtDefault?: number;
  salaryAdjustmentAmtError?: string;
}

const MIN_SALARY_AMT = 1;
const MAX_SALARY_AMT = 999999999;
const CHECK_LOWER_SALARY_AMT = 73999;
const CHECK_UPPER_SALARY_AMT = 5000000;

/**
 * SCRC060116 職員一覧　本俸月額更新
 * @Todo ファイル一括アップロード
 * @return SCRC060116 職員一覧　本俸月額更新
 */
const SCRC060116 = () => {
  const navigate = useNavigate();
  const { state: businessState } = useContext(BusinessContext);
  const { state: globalState, setState } = useContext(GlobalContext);
  const [facilityList, setFacilityList] = useState<any>([]);
  const [selectItem, setSelectItem] = useState<string>("");
  const [bodyInfoList, setBodyInfoList] = useState<any[]>([]);
  const [stateStaffList, setStateStaffList] = useState<
    (CustomType & StaffList)[]
  >([]);
  const [isOpenUpdate, setIsOpenUpdate] = useState(false);
  const [isOpenWarningLower, setIsOpenWarningLower] = useState(false);
  const [isOpenWarningUpper, setIsOpenWarningUpper] = useState(false);
  const currentFakeHeadTitleListRef = useRef<any>();
  const [resData, setResData] = useState<IAPI_STA020_Response>({});
  const [updateReq, setUpdateReq] = useState<{
    staffList: StaffListUpdate[];
    isCsvUpload: boolean;
  }>({ staffList: [], isCsvUpload: false });
  const [selectedFacilityNo, setSelectedFacilityNo] = useState<string>();
  const [openUploadComplete, setOpenUploadComplete] = useState(false);
  const isKiko =
    globalState.authInfo?.userType === authorityUserType.userTypeNumber.KIKO;
  const businessType = businessState.common?.businessType
    ?.toLowerCase()
    .replace("-", "_")!;
  const context = businessState[businessType as keyof typeof businessState] as
    | IJob_11Props
    | IJob_32Props;
  const pageValueRef = useRef(0);
  const notApplicablFacilityNo = "999";
  const [isNo999, setIsNo999] = useState(false);

  const debouncedSetState = useRef(
    _.debounce((newStateUpdater: any) => {
      setStateStaffList(newStateUpdater);
    }, 300)
  ).current;

  useEffect(() => {
    return () => {
      debouncedSetState.cancel();
    };
  }, [debouncedSetState]);

  useEffect(() => {
    setIsNo999(context?.facilityNo === notApplicablFacilityNo);
  }, [context?.facilityNo]);

  async function openingScreen() {
    setResData({ resultCd: "" });
    setBodyInfoList([]);
    setSelectItem("");

    // プルダウン用有効施設一覧参照API 呼び出し
    try {
      const res = await httpAPI_FAC019({
        contractorNo: isKiko
          ? businessState.common?.contractorNo
          : globalState.authInfo?.contractorNo,
        businessType: businessState.common?.businessType,
      });

      if (res.resultCd === "I0000") {
        let selectList = res.facilityList?.map((item) => {
          return {
            label: (item.facilityNo ?? "") + ":" + (item.facilityName ?? ""),
            value: item.facilityNo,
          };
        });

        setFacilityList(selectList);

        setState({
          ...globalState,
          errorMsgId: "",
        });
      } else {
        setState({
          ...globalState,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  }

  useEffect(() => {
    let bodyList = stateStaffList.map((item, index) => [
      {
        children: (item.staffNo ?? "") + ":" + (item.staffNameKanji ?? ""),
        forSort: item.staffNo,
      },
      {
        children: item.birthday,
        forSort: item.birthday,
        align: "center",
      },
      {
        children: TkGetCode(SexFlug, item.sex),
        forSort: item.sex,
        align: "center",
      },
      {
        children: changeAmountFormat(item.monthlySalaryAmt ?? ""),
        forSort: item.monthlySalaryAmt,
        align: "right",
      },
      {
        children: (
          <TkAmountInput
            key={`salaryTableAmt-${item.staffNo}`}
            onChange={(e: any) =>
              handleChangeAmount("salaryTableAmt", e.target.value, index)
            }
            wantToSetValue={item.salaryTableAmtDefault ?? 0}
            inputProps={{ maxLength: 9 }}
            error={!!item.salaryTableAmtError}
            errorMessage={item.salaryTableAmtError}
            disabled={item.loackState !== "0" || isNo999}
          />
        ),
        forSort: item.salaryTableAmt,
        align: "right",
      },
      {
        children: (
          <TkAmountInput
            key={`salaryAdjustmentAmt-${item.staffNo}`}
            onChange={(e: any) =>
              handleChangeAmount("salaryAdjustmentAmt", e.target.value, index)
            }
            wantToSetValue={item.salaryAdjustmentAmtDefault ?? 0}
            inputProps={{ maxLength: 9 }}
            error={!!item.salaryAdjustmentAmtError}
            errorMessage={item.salaryAdjustmentAmtError}
            disabled={item.loackState !== "0" || isNo999}
          />
        ),
        forSort: item.salaryAdjustmentAmt,
        align: "right",
      },
      {
        children: item.updateDate,
        forSort: item.updateDate,
        align: "center",
      },
    ]);

    setBodyInfoList(bodyList);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stateStaffList]);

  const handleChangeAmount = (
    field: "salaryTableAmt" | "salaryAdjustmentAmt",
    amount: number,
    index: number
  ) => {
    debouncedSetState((prev: any) => {
      return prev.map((d: any, i: any) => {
        if (i === index) {
          switch (field) {
            case "salaryTableAmt":
              d.salaryTableAmt = amount;
              d.monthlySalaryAmt = (amount ?? 0) + d.salaryAdjustmentAmt;
              d.salaryTableAmtError =
                amount === null || amount === undefined
                  ? TkPropertyMessageGet("TKMSG_SCR0043E")
                  : amount < MIN_SALARY_AMT
                  ? TkPropertyMessageGet(
                      "TKMSG_SCR0129E",
                      changeAmountFormat(MIN_SALARY_AMT)
                    )
                  : amount > MAX_SALARY_AMT
                  ? TkPropertyMessageGet(
                      "TKMSG_SCR0130E",
                      changeAmountFormat(MAX_SALARY_AMT)
                    )
                  : "";
              break;
            default:
              d.salaryAdjustmentAmt = amount;
              d.monthlySalaryAmt = (amount ?? 0) + d.salaryTableAmt;
              d.salaryAdjustmentAmtError =
                amount === null || amount === undefined
                  ? TkPropertyMessageGet("TKMSG_SCR0043E")
                  : amount > MAX_SALARY_AMT
                  ? TkPropertyMessageGet(
                      "TKMSG_SCR0130E",
                      changeAmountFormat(MAX_SALARY_AMT)
                    )
                  : "";
          }

          return d;
        }

        return d;
      });
    });
  };

  const chagelLatestUpdateDate = (year?: number) => {
    const currentFakeHeadTitleList = fakeHeadTitleList.forEach((item) => {
      if (item.className === "latestUpdateDate") {
        item.headTitle = `${year ? `${year}年度` : ""}最終更新日`;
      }
    });

    currentFakeHeadTitleListRef.current = currentFakeHeadTitleList;
  };

  const selectFacility = async (value: any, type: "select" | "search") => {
    type === "select" && setSelectItem(value);
    type === "select" && setSelectedFacilityNo(value);

    // 職員一覧本俸月額参照API 呼び出し
    if (value !== "") {
      try {
        const res = await httpAPI_STA020({
          contractorNo: isKiko
            ? businessState.common?.contractorNo
            : globalState.authInfo?.contractorNo,
          facilityNo: type === "select" ? value : selectItem,
          staffNo: context?.staffNo,
          staffName: type === "search" ? value : "",
        });

        if (res.resultCd === "I0000") {
          setResData(res);
          chagelLatestUpdateDate(res.year);

          let staffList: any = res.staffList?.map((item) => {
            return {
              ...item,
              salaryTableAmtDefault: item.salaryTableAmt,
              salaryAdjustmentAmtDefault: item.salaryAdjustmentAmt,
            };
          });
          pageValueRef.current = 0;
          setStateStaffList(staffList);
          setState({
            ...globalState,
            errorMsgId: "",
          });
        } else {
          setState({
            ...globalState,
            errorMsgId: res.resultCd,
          });
          setStateStaffList([]);
        }
      } catch (error) {
        navigate("/error");
      }
    }
  };

  useEffect(() => {
    if (context?.staffNo) {
      setFacilityList([
        {
          label:
            (context?.facilityNo ?? "") +
            ":" +
            (context?.facilityNo === notApplicablFacilityNo
              ? "対象外施設"
              : context?.facilityName ?? ""),
          value: context?.facilityNo,
        },
      ]);
    } else {
      openingScreen();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const businessCheck = (
    staffList: StaffListUpdate[],
    isCsvUpload: boolean
  ) => {
    setUpdateReq({ staffList, isCsvUpload });

    if (
      staffList?.some(
        (staff) => staff?.salaryTableAmt! <= CHECK_LOWER_SALARY_AMT
      )
    ) {
      setIsOpenWarningLower(true);
    } else if (
      staffList?.some(
        (staff) => staff?.salaryTableAmt! >= CHECK_UPPER_SALARY_AMT
      )
    ) {
      setIsOpenWarningUpper(true);
    } else {
      handleUpdate(staffList, isCsvUpload);
    }
  };

  const updateClick = () => {
    const errorCheck = stateStaffList.some(
      (item) => item?.salaryAdjustmentAmtError || item?.salaryTableAmtError
    );
    if (errorCheck) return;

    setIsOpenUpdate(true);
  };

  const okClick = () => {
    setIsOpenUpdate(false);

    const staffList = stateStaffList.map((item) => {
      return {
        staffNo: item.staffNo,
        year: resData.year,
        monthlySalaryAmt: item.monthlySalaryAmt,
        salaryTableAmt: item.salaryTableAmt,
        salaryAdjustmentAmt: item.salaryAdjustmentAmt,
        updateDateTime: item.updateDateTime,
      };
    });

    businessCheck(staffList, false);
  };

  // csvファイルアップロード
  const csvUploadSuccess = async (csvData: any) => {
    const makeStaffList = csvData.map((data: any) => {
      return {
        staffNo: data.staffNumber,
        year: parseInt(data.year),
        monthlySalaryAmt:
          parseInt(data.salary) + parseInt(data.salaryAdjustment),
        salaryTableAmt: parseInt(data.salary),
        salaryAdjustmentAmt: parseInt(data.salaryAdjustment),
        updateDateTime: null, // 本俸月額最終更新日
      };
    });

    businessCheck(makeStaffList, true);
  };

  const handleUpdate = async (
    staffList: StaffListUpdate[],
    isCsvUpload: boolean
  ) => {
    setIsOpenUpdate(false);
    setIsOpenWarningLower(false);
    setIsOpenWarningUpper(false);

    // 日々更新法人職員俸給更新API 呼び出し
    try {
      const res = await httpAPI_STA005({
        contractorNo: isKiko
          ? businessState.common?.contractorNo
          : globalState.authInfo?.contractorNo,
        staffList,
        businessType: businessState.common?.businessType,
        ...(!isCsvUpload && { facilityNo: selectItem }),
      });

      if (res.resultCd === "I0000") {
        setState({
          ...globalState,
          errorMsgId: "",
        });

        if (isCsvUpload) {
          setOpenUploadComplete(true);
        }

        await openingScreen();
        await selectFacility(selectItem, "select");
      } else {
        setState({
          ...globalState,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  const handleSortChange = (sort: any) => {
    if (!sort || sort.length === 0) return;
    const sortedArr = sort.map((item: any) => {
      return item[0].forSort;
    });
    const sortedStaffList = sortedArr
      .map((staffNo: any) => {
        let target = stateStaffList.find((staff) => staff.staffNo === staffNo);
        if (!target) return undefined;
        return {
          ...target,
          salaryTableAmtDefault: target.salaryTableAmt,
          salaryAdjustmentAmtDefault: target.salaryAdjustmentAmt,
        };
      })
      .filter((staff: any) => staff !== undefined);
    setStateStaffList(sortedStaffList);
  };

  const handlePageChange = (page: number) => {
    pageValueRef.current = page - 1;

    setStateStaffList((prev) =>
      prev.map((item) => ({
        ...item,
        salaryTableAmtDefault: item.salaryTableAmt,
        salaryAdjustmentAmtDefault: item.salaryAdjustmentAmt,
      }))
    );
  };

  return (
    <Box data-testid="SCRC060116PageForTest" className="tkSCRC060116">
      <TkInfoManual children={labelids.labelid.LBLC060116_01} rule={"\\n"} />
      {globalState.authInfo?.userType ===
        authorityUserType.userTypeNumber.KIKO && (
        <TkContractorAndNumberLine
          name="契約者(法人)名"
          no={
            businessState.common?.contractorNo +
            ":" +
            businessState.common?.contractorName
          }
        />
      )}
      <TkFakeTableLine
        {...facilitySelectList}
        selectPropsList={facilityList}
        onChange={(e: any) => selectFacility(e.target.value, "select")}
        disabled={!!context?.staffNo}
        setDefaultValue={
          facilityList?.length
            ? context?.staffNo
              ? context?.facilityNo
              : selectedFacilityNo
            : ""
        }
      />

      {!!selectItem && (
        <Box className="table">
          <TkDataTable
            headList={currentFakeHeadTitleListRef.current ?? fakeHeadTitleList}
            bodyList={bodyInfoList}
            count={bodyInfoList.length}
            defaultRowsPerPage={10}
            setPageValue={pageValueRef.current}
            dontResetPage
            pagin
            showUnit
            headerLeftComponent={
              <TkSearchForm
                listData={searchFormList}
                ruleSchema={searchFormSchema}
                onSearch={(e: any) => selectFacility(e.name, "search")}
              />
            }
            onSortChange={handleSortChange}
            onPageChange={(_, page) => handlePageChange(page)}
            useScroll
            stickyHeader
          />
        </Box>
      )}

      <Box className="tkBtnArea">
        <TkBackButton />
        {selectItem && (
          <TkButton
            onClick={updateClick}
            disabled={!bodyInfoList?.length || isNo999}
          >
            更新
          </TkButton>
        )}
        {!context?.staffNo && (
          <TkCsvUpload
            buttonName="CSVアップロード更新"
            type="houjinStaffMonthlySalary"
            onSuccess={csvUploadSuccess}
          />
        )}
      </Box>

      <TkMessageDialog
        open={isOpenUpdate}
        title="確認(職員の本俸月額を更新します)"
        contextText="　職員の本俸月額を更新します。よろしいですか？"
        okText="はい"
        cancelText="いいえ"
        onCancel={() => setIsOpenUpdate(false)}
        onOky={okClick}
      />
      <TkMessageDialog
        open={isOpenWarningLower}
        title="確認"
        contextText={TkPropertyMessageGet("TKMSG_SCR0035W")}
        okText="更新"
        cancelText="閉じる"
        onCancel={() => setIsOpenWarningLower(false)}
        onOky={() => handleUpdate(updateReq.staffList, updateReq.isCsvUpload)}
      />
      <TkMessageDialog
        open={isOpenWarningUpper}
        title="確認"
        contextText={TkPropertyMessageGet("TKMSG_SCR0036W")}
        okText="更新"
        cancelText="閉じる"
        onCancel={() => setIsOpenWarningUpper(false)}
        onOky={() => handleUpdate(updateReq.staffList, updateReq.isCsvUpload)}
      />
      <TkMessageDialog
        open={openUploadComplete}
        onOky={() => setOpenUploadComplete(false)}
        title="アップロード完了"
        contextText="　アップロードが完了しました。"
        okText="はい"
        cancelText=""
      />
    </Box>
  );
};

export default SCRC060116;
